import { Container } from "react-bootstrap";

export const ClientError = ({ code, errName, children }) => {
  const content = typeof children === "string" ? <p>{children}</p> : children;

  return (
    <>
      <Container className='p-0 mb-5 permit app-container err-component mt-5'>
        <div>
          <div className='text-center'>
            <h1>{code ?? 400}</h1>
            <h2 className='text-secondary'>{errName ?? "Bad Request"}</h2>
            {content ?? <p>The server could not understand the request.</p>}
            <p>These issues are sometimes temporary in nature and may resolve by following these steps:</p>
            <ul>
              <li>Refresh the page and try resubmitting.</li>
              <li>Come back in 30 minutes to see if the issue is resolved.</li>
              <li>If the issue persists, email us at UCFM@utahcounty.gov and let us know what happened.</li>
            </ul>
            <button
              onClick={() => {
                window.location.replace("https://codev.utahcounty.gov/fire-marshal");
              }}
              type='button'
              className='btn btn-outline-danger'
            >
              Return Home
            </button>
          </div>
        </div>
      </Container>
    </>
  );
};
